import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

//*MUI
import { Box, Divider, Popover, Typography } from '@mui/material';

//*files
import cssClasses from './UnitDetails.module.css';
import UnitIcon from '../../../../Assets/Images/Sustenance/UnitIcon.svg';
import LeadStatusChip from '../../../../Subcomponents/LeadStatusChip';
import Dot from '../../../Icons/Dot';
import Button from '../../../../Subcomponents/Button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  getProjectByProjectName,
  getUnitByUnitNo,
  getWingsIdByWingName,
} from '../../../../Services/SustenanceService';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';
import {
  getActiveLaunchInventory,
  getFutureLaunchInventory,
} from '../../../../Services/FastBooking';
import { getAllPricingPlansByProjectId } from '../../../../Services/PaymentPlans';

function UnitDetails() {
  const navigate = useNavigate();
  let loggedInUser = {};
  const [ChipStyle, setChipStyle] = useState(null);

  loggedInUser = useSelector((state) => state.Auth.user);

  const [checked, setChecked] = useState(false);
  const { projectId, wingName, unitNo } = useParams();

  const [ProjectData, setProjectData] = useState([]);
  const [AllWings, setAllWings] = useState([]);

  //*Base-Price-Data
  const [mergeIdData, setMergeIdData] = useState(false);
  const [mergeID, setMergeID] = useState('');
  const [Unit1, setUnit1] = useState('');
  const [Unit2, setUnit2] = useState('');
  const [TotalBsp, setTotalBsp] = useState([]);
  const [FloorRiseValue, setFloorRiseValue] = useState(0);
  const [plcValue, setPlcValue] = useState(0);
  const [Units, setUnits] = useState([]);
  const [CsvData, setCsvData] = useState([]);
  const [csvFlag, setCsvFlag] = useState(false);
  const [NotForSaleChip, setNotForSaleChip] = useState(false);
  const [SalesPersonName, setSalesPersonName] = useState('');
  const [PriceNotAdded, setPriceNotAdded] = useState(false);
  const [afterCancelUnitPrice, setAfterCancelUnitPrice] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(action.activeMenu('inventory'));
    getProject();
  }, []);

  useEffect(() => {}, [projectId]);

  useEffect(() => {
    defineChipColor();
  }, [Units?.inventoryStatusId?.status]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const IconOpen = Boolean(anchorEl);

  const id = IconOpen ? 'simple-popover' : undefined;
  const handleIconClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  function defineChipColor() {
    let obj = {};
    if (Units?.inventoryStatusId?.status === 'Available') {
      obj.chipColor = '#027A48';
      obj.chipBackgroundColor = '#D1FADF';
    } else if (Units?.inventoryStatusId?.status === 'On Hold') {
      obj.chipColor = '#B54708';
      obj.chipBackgroundColor = '#FEF0C7';
    } else if (Units?.inventoryStatusId?.status === 'Payment Pending') {
      obj.chipColor = '#B42318';
      obj.chipBackgroundColor = '#FEE4E2';
    } else if (Units?.inventoryStatusId?.status === 'Reserved') {
      obj.chipColor = '#6941C6';
      obj.chipBackgroundColor = '#F4EBFF';
    } else if (Units?.inventoryStatusId?.status === 'Locked') {
      obj.chipColor = '#344054';
      obj.chipBackgroundColor = '#F2F4F7';
    } else if (Units?.inventoryStatusId?.status === 'Preselected') {
      obj.chipColor = '#FF4405';
      obj.chipBackgroundColor = '#FFE6D5';
    } else if (Units?.inventoryStatusId?.status === 'Kyc Pending') {
      obj.chipColor = '#0E7090';
      obj.chipBackgroundColor = '#ECFDFF';
    } else if (Units?.inventoryStatusId?.status === 'Kyc Done') {
      obj.chipColor = '#2E90FA';
      obj.chipBackgroundColor = '#D1E9FF';
    } else if (Units?.inventoryStatusId?.status === 'SDR Payment Pending') {
      obj.chipColor = '#B54708';
      obj.chipBackgroundColor = '#FFFAEB';
    }
    setChipStyle(obj);
  }

  function getProject() {
    getProjectByProjectName(projectId)
      .then((resp) => {
        setProjectData(resp.data[0]);
        getUnitByUnitNo(unitNo)
          .then((res) => {
            console.log('getUnitByUnitNo', res);
            if (res.data[0].inventoryStatusId.status !== 'Available') {
              res.data[0].leadId.AllotmentPayment.forEach((lead) => {
                if (lead.leadId === res.data[0].leadId.leadId) {
                  setSalesPersonName(lead?.userId?.name);
                }
              });
            }
            getAllPricingPlansByProjectId(projectId, wingName)
              .then((response67) => {
                let filteredData = response67.data.filter(
                  ({ projectPricingId }) => projectPricingId !== null
                );

                if (resp.data[0]?.useCsvPrice === false) {
                  if (filteredData.length > 0) {
                    filteredData[0]?.projectPricingId?.basePrices?.forEach(
                      (_Item) => {
                        if (
                          res.data[0]?.inventoryTypeId?.inventoryTypeId ===
                          _Item.inventoryTypeId
                        ) {
                          setTotalBsp(_Item);
                          if (
                            filteredData[0]?.projectPricingId?.floorRise[0]
                              ?.value
                          ) {
                            filteredData[0]?.projectPricingId?.floorRise?.forEach(
                              (item) => {
                                if (
                                  item.from <= res.data[0]?.floorNo &&
                                  item.to >= res.data[0]?.floorNo
                                ) {
                                  if (item.type === 'Percentage') {
                                    if (
                                      res.data[0]?.saleableArea === _Item.sqft
                                    ) {
                                      const floorRise_per_unit =
                                        (parseInt(_Item.BSPTotal) *
                                          parseInt(item.value)) /
                                        100;
                                      setFloorRiseValue(floorRise_per_unit);
                                    }
                                  } else if (item.type === 'Value') {
                                    const floorRise_per_unit_by_Value =
                                      parseInt(item.value);
                                    setFloorRiseValue(
                                      floorRise_per_unit_by_Value
                                    );
                                  }
                                }
                              }
                            );
                          }

                          if (filteredData[0]?.projectPricingId?.plc) {
                            filteredData[0]?.projectPricingId?.plc?.forEach(
                              (item) => {
                                if (res.data[0].view === '') {
                                  if (item.type === 'Percentage') {
                                    if (
                                      res.data[0].saleableArea === _Item.sqft
                                    ) {
                                      const plc_per_unit =
                                        (parseInt(_Item.BSPTotal) *
                                          parseInt(item.value)) /
                                        100;
                                      setPlcValue(plc_per_unit);
                                    }
                                  } else if (item.type === 'Value') {
                                    const plc_per_unit_by_Value = parseInt(
                                      item.value
                                    );
                                    setPlcValue(plc_per_unit_by_Value);
                                  }
                                }
                              }
                            );
                          }
                        } else {
                          PriceNotAdded(true);
                        }
                      }
                    );
                  }
                } else if (resp.data[0]?.useCsvPrice === true) {
                  if (
                    res.data[0].BSP === null ||
                    (res.data[0].BSP === 0 &&
                      res.data[0].GST === 0 &&
                      res.data[0].SDR === 0)
                  ) {
                    setPriceNotAdded(true);
                    if (
                      res.data[0].BSP === 0 &&
                      res.data[0].GST === 0 &&
                      res.data[0].SDR === 0
                    ) {
                      setAfterCancelUnitPrice(true);
                    }
                  }
                  setCsvFlag(true);
                  setCsvData(res.data[0]);
                } else {
                  setPriceNotAdded(true);
                }
              })
              .catch((err) => {
                console.error('getAllPricingPlansByProjectId', err);
              });
            if (res?.data[0]?.inventoryMergeId) {
              setMergeIdData(true);
              setMergeID(res?.data[0]?.inventoryMergeId?.inventoryMergeId);
              setUnit1(res?.data[0]?.inventoryMergeId?.unit1Id);
              setUnit2(res?.data[0]?.inventoryMergeId?.unit2Id);
            }
            setUnits(res.data[0]);
          })
          .catch((err) => {});
      })
      .catch((err) => {});

    getWingsIdByWingName(wingName)
      .then((response) => {
        setAllWings(response.data[0]);
      })
      .catch((err) => {});

    getActiveLaunchInventory(unitNo)
      .then((active) => {
        getFutureLaunchInventory(unitNo)
          .then((future) => {
            if (active.data.length > 0 && future.data.length > 0) {
              setNotForSaleChip(true);
            }
          })
          .catch((err) => {});
      })
      .catch((err) => {});
  }

  function UnitStatusUpdate(respValue) {
    if (respValue === true) {
      getProject();
    }
  }

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
  }

  function RouteForAllotment() {
    navigate(
      `/home/Sustenance/Details/${projectId}/DirectAllotment/${wingName}/${unitNo}`
    );
  }

  return (
    <>
      <Box className={cssClasses.Container}>
        <Box className={cssClasses.HeaderTitle}>{ProjectData?.projectName}</Box>
        <Box className={cssClasses.SubTitle} mb={'1rem'} mt={'1rem'}>
          {ProjectData?.addressLine1} , {ProjectData?.addressLine2} ,{' '}
          {ProjectData?.addressLine3}
        </Box>

        <Divider />
        <Box className={cssClasses.BoxDiv}>
          <Box className={cssClasses.NumberTitle}>
            Unit :{' '}
            {mergeIdData && Units?.inventoryMergeId?.unit1No
              ? Units?.inventoryMergeId.unit1No <
                Units?.inventoryMergeId.unit2No
                ? `${Units?.inventoryMergeId?.unit1No} ,
             ${Units?.inventoryMergeId?.unit2No}`
                : `${Units?.inventoryMergeId?.unit2No} ,
             ${Units?.inventoryMergeId?.unit1No}`
              : Units?.unitNo}
            <Box component={'span'} className={cssClasses.Title}>
              {' '}
              {ProjectData?.displayInventoryType?.includes('Inventory Type') ? (
                <span> |{Units?.inventoryTypeId?.type}</span>
              ) : (
                ''
              )}
              {ProjectData?.displayInventoryType?.includes(
                'Display Unit Type'
              ) && Units?.displayUnitType !== null ? (
                <span>{'(' + Units?.displayUnitType + ')'}</span>
              ) : (
                ''
              )}{' '}
              | {Units?.saleableArea} sq.ft.
            </Box>
          </Box>

          <Box className={cssClasses.Title}>
            Wing :
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {/* {AllWings?.wingName} */}
              {AllWings?.displayName ? AllWings?.displayName : AllWings?.wingName}
            </Box>{' '}
          </Box>
          <Box className={cssClasses.Title}>
            Floor :
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {Units?.floorNo}{' '}
            </Box>
          </Box>

          <Box className={cssClasses.flexRow}>
            <LeadStatusChip
              style={{
                color: ChipStyle?.chipColor,
                backgroundColor: ChipStyle?.chipBackgroundColor,
              }}
              label={Units?.inventoryStatusId?.status}
              icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
            />
            {NotForSaleChip && (
              <LeadStatusChip
                style={{
                  color: '#B42318',
                  backgroundColor: '#FEE4E2',
                }}
                label={'Not for Sale'}
                icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
              />
            )}
          </Box>

          {PriceNotAdded ? (
            ''
          ) : (
            <Box className={cssClasses.Title}>
              {csvFlag ? (
                <Box
                  component={'span'}
                  ml={1}
                  className={cssClasses.NumberTitle}
                >
                  ₹{' '}
                  {mergeIdData && CsvData?.totalCost
                    ? numberWithCommas(
                        (
                          parseFloat(CsvData?.totalCost) +
                          parseFloat(CsvData?.totalCost)
                        ).toFixed(2)
                      )
                    : numberWithCommas(
                        (
                          parseFloat(CsvData?.totalCost)
                        ).toFixed(2)
                      )}
                </Box>
              ) : (
                <Box
                  component={'span'}
                  ml={1}
                  className={cssClasses.NumberTitle}
                >
                  ₹{' '}
                  {mergeIdData && TotalBsp.Total
                    ? numberWithCommas(
                        (
                          parseFloat(TotalBsp.Total) +
                          parseFloat(TotalBsp.Total) +
                          FloorRiseValue
                        ).toFixed(2)
                      )
                    : numberWithCommas(
                        (parseFloat(TotalBsp.Total) + FloorRiseValue).toFixed(2)
                      )}
                </Box>
              )}
            </Box>
          )}
        </Box>

        <Box className={cssClasses.flexRow2} margin={'5rem 0'}>
          <Box className={cssClasses.flexRow2}>
            <Box width={'15rem'}>
              <img src={UnitIcon} alt={''} height={'100%'} width={'100%'} />
            </Box>
            <Box className={cssClasses.unitDetails}>
              <Box className={cssClasses.flexRow2} width={'50%!important'}>
                <Box margin={'0rem 2rem'} width={'100%'}>
                  <Box className={cssClasses.LeadInfo}>Price Details:</Box>
                  {PriceNotAdded ? (
                    <Box
                      className={cssClasses.Title}
                      display={'flex'}
                      flexDirection={'row'}
                    >
                      <LeadStatusChip
                        style={{ color: '#000000', backgroundColor: '#ececec' }}
                        label={'Price not Added!'}
                        icon={<Dot width={'0.6rem'} height={'0.6rem'} />}
                      />
                      {afterCancelUnitPrice && (
                        <Box mt={0.2} ml={1}>
                          <InfoOutlinedIcon
                            onClick={handleClick}
                            style={{
                              width: '2rem',
                              height: '2rem',
                              color: '#344054',
                            }}
                          ></InfoOutlinedIcon>
                          <Popover
                            id={id}
                            open={IconOpen}
                            anchorEl={anchorEl}
                            onClose={handleIconClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right',
                            }}
                          >
                            <Typography
                              style={{ fontSize: '1.4rem' }}
                              sx={{ p: 2 }}
                            >
                              Unit is recently cancelled.Reprice is pending
                            </Typography>
                          </Popover>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Box className={cssClasses.unitPriceWrap}>
                      <Box className={cssClasses.priceTitle}>
                        <Box className={cssClasses.NumberLabel}>
                          Agreement Value:{' '}
                        </Box>
                        {csvFlag ? (
                          <Box className={cssClasses.NumberTitle}>
                            {mergeIdData && CsvData?.BSP
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(CsvData?.BSP) +
                                    parseFloat(CsvData?.BSP)
                                )}`
                              : ` ₹ ${numberWithCommas(CsvData?.BSP)}`}
                          </Box>
                        ) : (
                          <Box className={cssClasses.NumberTitle}>
                            {mergeIdData && TotalBsp?.BSPTotal
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(TotalBsp?.BSPTotal) +
                                    parseFloat(TotalBsp?.BSPTotal)
                                )}`
                              : ` ₹ ${numberWithCommas(TotalBsp?.BSPTotal)}`}
                          </Box>
                        )}
                      </Box>
                      <Box className={cssClasses.priceTitle}>
                        <Box className={cssClasses.NumberLabel}>GST : </Box>
                        {csvFlag ? (
                          <Box className={cssClasses.NumberTitle}>
                            {mergeIdData && CsvData.GST
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(CsvData.GST) +
                                    parseFloat(CsvData.GST)
                                )}`
                              : ` ₹ ${numberWithCommas(+CsvData.GST)}`}
                          </Box>
                        ) : (
                          <Box className={cssClasses.NumberTitle}>
                            {mergeIdData && TotalBsp.GST
                              ? ` ₹ ${numberWithCommas(
                                  parseFloat(TotalBsp.GST) +
                                    parseFloat(TotalBsp.GST)
                                )}`
                              : ` ₹ ${numberWithCommas(+TotalBsp.GST)}`}
                          </Box>
                        )}
                      </Box>
                      {csvFlag ? (
                        <Box className={cssClasses.priceTitle}>
                          <Box className={cssClasses.NumberLabel}>SDR : </Box>
                          <Box className={cssClasses.NumberTitle}>
                            {CsvData.SDR
                              ? ` ₹ ${numberWithCommas(CsvData?.SDR)}`
                              : '-'}
                          </Box>
                        </Box>
                      ) : (
                        <Box className={cssClasses.priceTitle}>
                          <Box className={cssClasses.NumberLabel}>SDR : </Box>
                          <Box className={cssClasses.NumberTitle}>
                            {TotalBsp.REG
                              ? ` ₹ ${numberWithCommas(TotalBsp.SDR)}`
                              : '-'}
                          </Box>
                        </Box>
                      )}

                      {csvFlag === false && (
                        <Box className={cssClasses.priceTitle}>
                          <Box className={cssClasses.NumberLabel}>
                            FloorRise :{' '}
                          </Box>
                          <Box className={cssClasses.NumberTitle}>
                            ₹
                            {FloorRiseValue
                              ? numberWithCommas(FloorRiseValue)
                              : '-'}
                          </Box>
                        </Box>
                      )}
                      <Box className={cssClasses.priceTitle}>
                        <Box className={cssClasses.NumberLabel}>Total : </Box>
                        {csvFlag ? (
                          <Box className={cssClasses.NumberTitle}>
                            ₹{' '}
                            {mergeIdData && CsvData?.BSP
                              ? numberWithCommas(
                                  (
                                    parseFloat(CsvData?.BSP) +
                                    parseFloat(CsvData?.BSP) +
                                    parseFloat(CsvData?.SDR) +
                                    parseFloat(CsvData?.GST) +
                                    parseFloat(CsvData?.GST)
                                  ).toFixed(2)
                                )
                              : numberWithCommas(
                                  (
                                    parseFloat(CsvData?.BSP) +
                                    parseFloat(CsvData?.SDR) +
                                    parseFloat(CsvData?.GST)
                                  ).toFixed(2)
                                )}
                          </Box>
                        ) : (
                          <Box ml={1} className={cssClasses.NumberTitle}>
                            ₹{' '}
                            {mergeIdData && TotalBsp.BSPTotal
                              ? numberWithCommas(
                                  (
                                    parseFloat(TotalBsp.BSPTotal) +
                                    parseFloat(TotalBsp.BSPTotal) +
                                    parseFloat(TotalBsp.REG) +
                                    parseFloat(TotalBsp.GST) +
                                    parseFloat(TotalBsp.GST) +
                                    FloorRiseValue
                                  ).toFixed(2)
                                )
                              : numberWithCommas(
                                  (
                                    parseFloat(TotalBsp.BSPTotal) +
                                    parseFloat(TotalBsp.REG) +
                                    parseFloat(TotalBsp.GST) +
                                    FloorRiseValue
                                  ).toFixed(2)
                                )}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
              {(Units?.inventoryStatusId?.status ||
                Units?.inventoryStatusId?.status === 'On Hold' ||
                Units?.inventoryStatusId?.status === 'Payment Pending') && (
                <>
                  <Box width={'50%!important'}>
                    <Box className={cssClasses.LeadInfo}>Lead Info:</Box>
                    <Box className={cssClasses.unitPriceWrap}>
                      <Box
                        className={cssClasses.Title}
                        display={'flex'}
                        flexDirection={'row'}
                      >
                        Lead Name :{' '}
                        <Box ml={1} className={cssClasses.NumberTitle}>
                          {Units?.leadId?.personId?.name
                            ? Units?.leadId?.personId?.name
                            : '-'}
                        </Box>{' '}
                      </Box>
                      <Box
                        className={cssClasses.Title}
                        display={'flex'}
                        flexDirection={'row'}
                      >
                        Lead ID:{' '}
                        <Box ml={1} className={cssClasses.NumberTitle}>
                          {Units?.leadId?.leadDisplayId
                            ? 'VJ' +
                              Units?.leadId?.leadDisplayId.replace(
                                Units?.leadId?.leadDisplayId.substring(8, 12),
                                '-' +
                                  Units?.leadId?.leadDisplayId.substring(8, 12)
                              )
                            : '-'}
                        </Box>
                      </Box>
                      {loggedInUser.roleId.level === 1 && (
                        <>
                          <Box
                            className={cssClasses.Title}
                            display={'flex'}
                            flexDirection={'row'}
                          >
                            Lead Contact No :{' '}
                            <Box ml={1} className={cssClasses.NumberTitle}>
                              {Units?.leadId?.personId?.contactNumber
                                ? '+' + Units?.leadId?.personId?.contactNumber
                                : '-'}
                            </Box>
                          </Box>

                          <Box
                            className={cssClasses.Title}
                            display={'flex'}
                            flexDirection={'row'}
                          >
                            Lead Email Id :{' '}
                            <Box ml={1} className={cssClasses.NumberTitle}>
                              {Units?.leadId?.personId?.email
                                ? Units?.leadId?.personId?.email
                                : '-'}
                            </Box>
                          </Box>
                        </>
                      )}

                      <Box
                        className={cssClasses.Title}
                        display={'flex'}
                        flexDirection={'row'}
                      >
                        SM :{' '}
                        <Box ml={1} className={cssClasses.NumberTitle}>
                          {SalesPersonName ? SalesPersonName : '-'}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>

        <Box height={'25rem'}></Box>
      </Box>
      {Units &&
        Units.inventoryStatusId?.status === 'Available' &&
        !NotForSaleChip && (
          <Box Box className={cssClasses.footerDiv}>
            <Box className={cssClasses.RightButtonWrap} ml={'68%'}>
              <Button
                style={{
                  color: '#fff',
                  backgroundColor: '#1570EF',
                  fontSize: '1.4rem',
                  lineHeight: '2rem',
                  fontFamily: 'Roboto-Regular',
                }}
                padding={'0.8rem 2.6rem'}
                btnName={'Alot'}
                clicked={() => RouteForAllotment()}
              />
            </Box>
          </Box>
        )}
    </>
  );
}

export default UnitDetails;
